<template>
  <div class="object-select-input clearfix">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        Start Point
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text" :value="options.origin" readonly/>
      </div>
    </div>
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        End Point
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <template v-if="options.objects.length > 1 || !options.oneWayTrip">
          <select class="form-control" ref="dropdown"
          :name="options.name"
          @choice="validate($event.detail.choice.value)">
            <option v-for="object in options.objects" :key="object.uuid"
            :value="object.uuid"
            :checked="object.uuid === value">{{ object[options.objectName] }}</option>
          </select>
        </template>
        <template v-if="options.objects.length <= 1 && options.oneWayTrip">
          <input class="form-control" type="text" :value="options.objects[0] ? options.objects[0].dropdownLabel : 'No available lots'" readonly/>
          <input class="form-control" :name="options.name" type="hidden" :value="options.objects[0] ? options.objects[0].uuid : ''"/>
        </template>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/vuex/api'
import Choices from 'choices.js'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'OneWayTripInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'object_select',
          objectName: 'fullName',
          titleName: 'organizationName',
          value: '',
          objects: [],
          required: false,
          oneWayTrip: false
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      choices: false,
      startDate: null,
      endDate: null
    }
  },
  computed: {
    label () {
      return this.options.singleLabel
        ? this.options.singleLabel
        : this.options.label
    },
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      return 'End point is required'
    }
  },
  mounted () {
    let options = this.options
    function callbackOnCreateTemplates (template) {
      let classNames = this.config.classNames
      return {
        item: (data) => {
          let object = options.objects[data.id - 1]
          let label = data.label
          let closeButton = `
          <button class="${classNames.button}" data-button>Remove item</button>
          `
          if (data.id && object) {
            if (object[options.iconName]) {
              label = `<span class="fa fa-fw ${object[options.iconName]}"></span> ${data.label}`
            }
          }
          if (data.title) {
            label = `${data.label} ${data.title}`
          }
          if (this.config.removeItemButton) {
            label = `${label} ${closeButton}`
          }
          return template(`
          <div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : classNames.itemSelectable}"  data-item data-id="${data.id}" data-value="${data.value}" ${data.active ? 'aria-selected="true"' : ''} ${data.disabled ? 'aria-disabled="true"' : ''}>
            ${label}
          </div>
          `)
        },
        choice: (data) => {
          let object = options.objects[data.id - 1]
          let label = data.label
          if (data.id && object) {
            if (object[options.iconName]) {
              label = `<span class="fa fa-fw ${object[options.iconName]}"></span> ${data.label}`
            }
          }
          return template(`
          <div class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}" data-select-text="${this.config.itemSelectText}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} data-id="${data.id}" data-value="${data.value}" ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}>
            ${label}
          </div>
          `)
        }
      }
    }
    if (this.$refs.dropdown) {
      let $vm = this
      /* eslint-disable no-new */
      this.choices = new Choices(this.$refs.dropdown, {
        callbackOnCreateTemplates,
        placeholder: true,
        removeItemButton: true,
        itemSelectText: '',
        placeholderValue: 'Select a ' + this.label,
        searchPlaceholderValue: 'Select a ' + this.label,
        fuseOptions: {
          threshold: 0.6
        },
        searchResultLimit: 6,
        searchFields: ['label'],
        callbackOnInit: function () {
          let arr = this.store.getItemsFilteredByActive()
          if (!$vm.value) {
            if (arr.length > 0) {
              let value = arr.pop().value
              this.removeItemsByValue(value)
            }
          }
        }
      })
    }
  },
  watch: {
    'options.objects': function (oldVal, newVal) {
      this.updateChoices()
    }
  },
  methods: {
    runWatcher (val, name) {
      switch (name) {
        case 'dateRange':
          this.getLots(val)
          break
      }
    },
    async getLots (val) {
      let instance = new Api()
      let results = await instance.getVacantLots({
        startDate: val.startDate,
        endDate: val.endDate,
        oneWayTrip: this.options.oneWayTrip,
        carUuid: this.options.carUuid
      })
      results.map(function (val, i) {
        results[i] = { value: val.uuid, label: val.dropdownLabel }
      })
      if (this.choices) {
        if (this.choices.getValue()) {
          let found = results.find(el => el.value === this.choices.getValue().value)
          if (!found) {
            this.choices.clearInput()
            if (this.choices.containerInner.children[1].children[0]) {
              this.choices.containerInner.children[1].children[0].innerHTML = ''
            }
          }
        }
        this.choices.setChoices(results, 'value', 'label', true)
      }
    },
    validate (val = this.value) {
      this.$emit('input', val)
      if (this.options.required) {
        this.isDirty = true
        this.isValid = val.length > 0
      } else {
        this.isValid = true
      }
    },
    async updateChoices () {
      if (this.choices) {
        // updates the choices input with new values
        this.choices.clearInput()
        this.choices.config.searchPlaceholderValue = 'Select a ' + this.options.label
        this.choices.config.placeholderValue = 'Select a ' + this.options.label
        if (this.choices.containerInner.children[1].children[0]) {
          this.choices.containerInner.children[1].children[0].innerHTML = ''
        }
        this.choices.containerOuter.children[1].children[0].placeholder = 'Select a ' + this.options.label
        this.choices.setChoices(this.options.objects, 'uuid', this.options.objectName, true)
        await this.$nextTick()
        if (this.value) {
          // let val = this.choices.getValue(true)
          this.choices.removeHighlightedItems()
          this.choices.removeActiveItems()
          this.choices.setValueByChoice(this.value)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/OneWayTripInput.vue